import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
import { addOfferToBooking } from "../../../app/api/postBooking";
import { BaseAction } from "../../../core/actions/BaseAction";
import { IDefaultActionResult } from "../../../Orchestrator/Types/Interface/ActionParams/DefaultActionResult";
import { prepareBookingSummaryAction } from "../../LogicActions/Checkout/Summary/PrepareBookingSummaryAction";
import { getBooking } from "../../../app/api/getBooking";
import { IBookingResponse } from "../../../Orchestrator/Types/Index";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
dayjs.extend(timezone);
dayjs.extend(utc);

export class AddOfferToBookingAction extends BaseAction<IDefaultActionResult, IDefaultActionResult> {

    override async run(): Promise<IDefaultActionResult> {
        let actionResult: IDefaultActionResult = {
            data: null,
            message: "",
            status: "fail"
        }
        try {
            const { data, status } = this.params!
            if (data && status === "success") {
                const uniqueOffers = data?.uniqueOffers || [];
                const normalizedOffers: any[] = [];
                
                uniqueOffers.forEach((offer: any) => {
                    if (offer && offer.offerId) {
                        if (Array.isArray(offer.offerId)) {
                            offer.offerId.forEach((id: string) => {
                                normalizedOffers.push({
                                    offerId: id,
                                    passengerRefs: offer.passengerRefs || []
                                });
                            });
                        } else {
                            normalizedOffers.push({
                                offerId: offer.offerId,
                                passengerRefs: offer.passengerRefs || []
                            });
                        }
                    }
                });

                const payload = {
                    offers: normalizedOffers
                }

                const bookingId = data?.bookingId || []
                if (normalizedOffers.length > 0 && bookingId) {
                    const addOfferResponse: any = await addOfferToBooking(bookingId, payload);
                    if (addOfferResponse.status === 'ok' && addOfferResponse.answer) {

                        const bookingResponseData = await getBooking(bookingId)
                        if (bookingResponseData.status === 'ok' && bookingResponseData.answer) {
                            const bookingResponse: IBookingResponse = bookingResponseData.answer;
                            updateRecoilState('bookingResponseAtom', bookingResponse);
                            prepareBookingSummaryAction.setParams(bookingResponse.booking)
                            await prepareBookingSummaryAction.execute()
                            actionResult.status = "success"
                            updateRecoilState("isModalVisibleAtom", false);
                            updateRecoilState("isRoundTripInboundModalVisibleAtom", false);
                            updateRecoilState("isRoundTripModalVisibleAtom", false);
                        }

                    }
                }
            }
        }
        catch (error) {
            console.log("Error during booking again:", error);
            actionResult.message = "Something went wrong"
        } finally {
            return actionResult
        }
    }
}

export const addOfferToBookingAction = new AddOfferToBookingAction(); 